const primeState = {
  issuingAssets: {
    assets_data: {},
    transaction_id: undefined,
  },
  partnerDetails: {
    onboarding_center_id: "",
  },
  driverDetails: {
    pan_number: "",
    phone_number: "",
    driver_id: "",
  },
};

export default primeState;
